import type { ProgressBarDesignTokens } from '@primeuix/themes/types/progressbar';

 export default {
    root: {
        height: "1.25rem",
        background: "{content.border.color}",
        borderRadius: "{border.radius.round}"
    },
    label: {
        color: "{primary.contrast.color}",
        fontSize: "0.75rem",
        fontWeight: "{font.weight.semibold}"
    },
    value: {
        background: "{primary.color}"
    }
} satisfies ProgressBarDesignTokens;